import { useEffect } from "react";
import { useSelector } from "react-redux";

import { selectCurrentFarm } from "src/modules/farms/shared/selectors/farm.selector";
import { toggleFeature } from "src/shared/utils/use-module-api";

export function useFarmFeatureToggles(): void {
  const currentFarm = useSelector(selectCurrentFarm);

  useEffect(() => {
    if (!currentFarm) {
      return;
    }
    const {
      allowAssetsFromAllFarms,
      allowSeedsFromAllCrops,
      allowTechFromAllTechSubgroups,
    } = currentFarm;

    toggleFeature("allowAssetsFromAllFarms", allowAssetsFromAllFarms);
    toggleFeature("allowSeedsFromAllCrops", allowSeedsFromAllCrops);
    toggleFeature("allowTechFromAllTechSubgroups", allowTechFromAllTechSubgroups);
  }, [currentFarm]);
}
